import React from 'react';
import { createPortal } from 'react-dom';

/**
 * 선택 영역을 "가짜 하이라이트"로 보여주는 오버레이 컴포넌트.
 * - absolute 좌표(문서 기준)로 그려서 스크롤에도 안정적으로 대응
 * - pointer-events: none (클릭 통과)
 */
export default function HighlightOverlay({ rects, color = 'rgba(0, 200, 180, 0.2)', zIndex = 999 }) {
  if (!rects || rects.length === 0) return null;

  return createPortal(
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: 0,
        height: 0,
        pointerEvents: 'none',
        zIndex,
      }}
    >
      {rects.map((r, idx) => (
        <div
          key={idx}
          style={{
            position: 'absolute',
            top: `${r.top}px`,
            left: `${r.left}px`,
            width: `${r.width}px`,
            height: `${r.height}px`,
            background: color,
            borderRadius: '4px',
            pointerEvents: 'none',
          }}
        />
      ))}
    </div>,
    document.body
  );
}

